<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h5>Categorias da Plataforma</h5>
      <v-btn
        color="primary"
        @click="openCreateDialog"
        small
        :disabled="!hasPermission(256)"
      >
        <v-icon left small>mdi-plus</v-icon>
        Nova Categoria
      </v-btn>
    </div>

    <v-row v-if="categories.length === 0" class="ma-0">
      <v-col cols="12" class="text-center py-8">
        <v-icon size="64" color="grey lighten-1">mdi-tag-multiple-outline</v-icon>
        <div class="text-h6 grey--text mt-2">Nenhuma categoria encontrada</div>
      </v-col>
    </v-row>

    <v-row v-else class="ma-0">
      <v-col 
        v-for="category in categories" 
        :key="category.id" 
        cols="12" 
        sm="6" 
        md="4"
      >
        <v-card outlined class="elevation-0 rounded-lg">
          <v-card-text class="pb-2">
            <div class="d-flex align-center mb-3">
              <v-avatar
                size="48"
                :color="platform?.colors?.light?.primary || '#6366f1'"
                class="white--text mr-3"
              >
                <v-img
                  v-if="category.icon"
                  :src="category.icon"
                  :alt="category.name"
                  contain
                />
                <span v-else class="text-h6">
                  {{ category.name.charAt(0).toUpperCase() }}
                </span>
              </v-avatar>
              <div class="flex-grow-1">
                <div class="text-h6 mb-1">{{ category.name }}</div>
                <v-chip small outlined>
                  {{ category._count?.Party || 0 }} {{ (category._count?.Party || 0) === 1 ? 'evento' : 'eventos' }}
                </v-chip>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer />
            <v-btn
              icon
              small
              @click="editCategory(category)"
              :disabled="!hasPermission(256)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              icon
              small
              color="error"
              @click="deleteCategory(category)"
              :disabled="!hasPermission(256) || category._count?.Party > 0"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Create/Edit Dialog -->
    <category-create-edit-dialog
      v-model="createEditDialog"
      :platform="platform"
      :category="selectedCategory"
      @saved="onCategorySaved"
    />

    <!-- Delete Confirmation Dialog -->
    <category-delete-dialog
      v-model="deleteDialog"
      :platform="platform"
      :category="categoryToDelete"
      @deleted="onCategoryDeleted"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import platformService from "@/services/admin/platform";
import CategoryCreateEditDialog from "./CategoryCreateEditDialog.vue";
import CategoryDeleteDialog from "./CategoryDeleteDialog.vue";

export default {
  name: "PlatformCategories",
  components: {
    CategoryCreateEditDialog,
    CategoryDeleteDialog
  },
  props: {
    platform: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      categories: [],
      createEditDialog: false,
      deleteDialog: false,
      selectedCategory: null,
      categoryToDelete: null
    };
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"])
  },
  watch: {
    platform: {
      handler() {
        if (this.platform?.id) {
          this.loadCategories();
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadCategories() {
      if (!this.platform?.id) return;
      
      try {
        const response = await platformService.getCategories(this.platform.id);
        this.categories = response.categories || [];
      } catch (error) {
        console.error("Erro ao carregar categorias:", error);
      }
    },

    openCreateDialog() {
      this.selectedCategory = null;
      this.createEditDialog = true;
    },

    editCategory(category) {
      this.selectedCategory = category;
      this.createEditDialog = true;
    },

    deleteCategory(category) {
      this.categoryToDelete = category;
      this.deleteDialog = true;
    },

    onCategorySaved() {
      this.loadCategories();
    },

    onCategoryDeleted() {
      this.loadCategories();
    }
  }
};
</script>

<style scoped>
.gap-1 {
  gap: 4px;
}

.gap-3 {
  gap: 12px;
}
</style> 